// extracted by mini-css-extract-plugin
module.exports = {"container":"f96Dm","label":"gIxmC","form":"_05HNF","button":"EWyPR","error":"_1nwxN","footerLink":"SeF2n"};